import { ApiContextType } from '@/server/api-fetch';
import { PageType } from './page';
import { setDataLayer } from '@/hooks/use-gtm';
import { AppContextType } from '@/contexts/app-context';

export const SEARCH_QUERY_KEY = 'search';
export const SEARCH_FAQS_QUERY_KEY = 'search_faqs';

export type SearchResult = PageType & {
    _formatted: PageType & {
        post_content: TrustedHTML;
    };
};

export type SearchResponse = {
    hits: SearchResult[];
    estimatedTotalHits: number;
    limit: number;
    offset: number;
    processingTimeMs: number;
};

export type SearchFaqsResponse = {
    hits: {
        id: number;
        title: string;
        content: string;
        permalink: string;
        _formatted: {
            id: string;
            title: string;
            content: string;
        };
    }[];
    estimatedTotalHits: number;
    query: string;
    limit: number;
    offset: number;
};

export const searchQuery = async (searchTerm: string, page = 1, context: ApiContextType, isClusterPage = false) => {
    const index = `${context.siteId}-${context.role}`;

    // @TODO: This is not currently implemented in the old FE so I'm choosing to
    // leave this unimplemented for now @richard.sweeney
    if (isClusterPage) {
        // const language = state.localization.currentLanguage;
        // const role = state.settings.role || 'draft';
        // rootPath = `&rootPath=${state.pages.current.match(/^[a-z-]+/)[0]}`;
        // index = `${role}-single-cluster-document-${language}`;
    }

    try {
        setDataLayer({ action: 'search', category: 'search', label: searchTerm });

        const host = typeof window === 'undefined' ? 'http://localhost' : '';
        const results = await fetch(`${host}/api/search/${index}/${page}?q=${encodeURIComponent(searchTerm)}`);
        const data = (await results.json()) as SearchResponse;
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const searchFaqsQuery = async (searchTerm: string, context: AppContextType) => {
    const index = `${context.siteId}_faq`;

    try {
        const results = await fetch(`/api/search-faqs/${index}?q=${encodeURIComponent(searchTerm)}`);
        const data = (await results.json()) as SearchFaqsResponse;

        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
